import { render, staticRenderFns } from "./VModal.vue?vue&type=template&id=f3398508&"
import script from "./VModal.vue?vue&type=script&lang=ts&"
export * from "./VModal.vue?vue&type=script&lang=ts&"
import style0 from "./VModal.vue?vue&type=style&index=0&id=f3398508&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports